import queryString from "query-string";
import { useEffect, useState } from "react";

import * as CalculatorStepTracker from "@/services/tracking/trackers/tools/calculators/calculatorStep.tracker";
import { CALCULATOR_KEYS } from "@/services/tracking/trackers/tools/calculators/config";
import { parseQueryString, validNumber } from "@/utils/calculators";

import Calculation from "./calculation/calculation.component";
import Result from "./result/result.component";

const CementplateCalculator = () => {
    const q = queryString.parse(location.search);

    const [cementplateLength, setCementplateLength] = useState(
        parseQueryString(q.cementplateLength)
    );

    const [cementplateWidth, setCementplateWidth] = useState(
        parseQueryString(q.cementplateWidth)
    );

    const [cementplateThickness, setCementplateThickness] = useState(
        parseQueryString(q.cementplateThickness)
    );

    const [cementplateArea, setCementplateArea] = useState(0);
    const [cementplateVolume, setCementplateVolume] = useState(0);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        setCementplateArea(determineCementplateArea());
        setCementplateVolume(determineCementplateVolume());
        CalculatorStepTracker.trackStart(CALCULATOR_KEYS.cementPlate);
    }, []);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        setCementplateArea(determineCementplateArea());
        setCementplateVolume(determineCementplateVolume());
    }, [cementplateLength, cementplateWidth, cementplateThickness]);

    const determineCementplateArea = () => {
        const length = cementplateLength;
        const width = cementplateWidth;
        const area = Number(length * width);

        return validNumber(area) ? area : 0;
    };

    const determineCementplateVolume = () => {
        const length = cementplateLength;
        const width = cementplateWidth;
        const height = cementplateThickness * 0.01; // convert cm to m
        const volume = Number(length * width * height);

        return validNumber(volume) ? volume : 0;
    };

    const setCalculationValue = (field: string, value: string) => {
        const numberValue = parseFloat(value.replace(",", "."));
        switch (field) {
            case "cementplateLength": {
                setCementplateLength(numberValue);
                break;
            }
            case "cementplateWidth": {
                setCementplateWidth(numberValue);
                break;
            }
            case "cementplateThickness": {
                setCementplateThickness(numberValue);
                break;
            }
        }
        CalculatorStepTracker.trackSubmit(CALCULATOR_KEYS.cementPlate);
    };

    const calculationProps = {
        setCalculationValue: setCalculationValue,
        cementplateLength: cementplateLength,
        cementplateWidth: cementplateWidth,
        cementplateThickness: cementplateThickness
    };
    const resultProps = {
        cementplateArea: cementplateArea,
        cementplateVolume: cementplateVolume,
        mailParams: {
            cementplateLength: cementplateLength,
            cementplateWidth: cementplateWidth,
            cementplateThickness: cementplateThickness
        }
    };

    return (
        <div id="calculator">
            <Calculation {...calculationProps} />
            <Result {...resultProps} />
        </div>
    );
};

export { CementplateCalculator };
